import caret_purple_down from 'src/assets/caret_purple_down.png';
import app_store from 'src/assets/app_store.png';
import play_store from 'src/assets/play_store.png';

import CloseIcon from '@mui/icons-material/Close'
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined'
import HeadsetIcon from '@mui/icons-material/Headset'
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo'
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat'
import { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import rightCaret from 'src/assets/right_caret.svg'
import { APP_CONSTANTS } from 'src/consumer/constants'
import { UnsecureSetupContext } from 'src/consumer/context/UnsecureSetupContext'
import { titleCaseWithExceptionWords } from 'src/consumer/helpers/utilFunctions'
import {
  getAllCoursesCategoryItemsForPublic,
  getDataWithoutParams,
  getFeatureList,
} from 'src/consumer/services/featureServices'
import { useScreenSize } from 'src/customHooks/customHooks'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import {
  ALPDarkButton,
  ALPFilterFinalActionButton,
  ALPFilterOption,
  ALPFilterOptionHeading,
  ALPFilterOptionsContainer,
  ALPMainSectionCaret,
  ALPMainSectionContainer,
  ALPMainSectionDescription,
  ALPMainSectionHeading,
  ALPMainSectionInternalContainer,
  ALPMainSectionItemBackground,
  ALPMainSectionItemContainer,
  ALPMainSectionItemContainerOnClickOverride,
  ALPMainSectionItemDetails,
  ALPMainSectionItemHeading,
  ALPMainSectionItemStartText,
  ALPMainSectionItemsContainer,
  IASACVarOneBackground,
  IASACVarOneBackgroundImageOne,
  IASACVarOneBackgroundImageTwo,
  IASACVarOneButton,
  IASACVarOneContainer,
  IASACVarOneDescription,
  IASACVarOneHeading,
  IASCDetailsContainer,
  IWHDAIVarOneContainer,
  IWHDAIVarOneDescription,
  IWHDAIVarOneHeadline2,
  IWHDAIVarOneImage,
} from '../AssessmentsListingPage/AssessmentListingPageStyles'
import { DisplayFlexColumn } from '../DailyPlay/DailyPlayStyles'
import { getDisplayEventTypesOfMentor } from '../Professionals List Page'
import {
  getArrayOfLanguagesOfMentor,
  getYearsOfExperienceFromProfile,
} from '../ServiceProvidersListingPage/ServiceProvidersListingComponents'
import { RelatedAppFeaturesStyledHeading } from '../ServiceProvidersListingPage/ServiceProvidersListingComponentsStyles'
import { ArticleLayoutCardCarouselComponent } from '../Tile/components/layoutCards/ArticleLayoutCard'
import { SquareCardCarouselComponent } from '../Tile/components/layoutCards/SquareMidCard'
import { MentorCardPortraitCarouselComponent } from '../Tile/components/layoutCards/mentorCardPortrait/MentorCardPortrait'
import {
  ADCContainer,
  ADCImageOne,
  ADCImageTwo,
  ADCImagesAndDetails,
  ADCImagesContainer,
  ADCStoreButtonsContainer,
  ADCSubtext,
  ADCTitle,
  ActionButtonTypeOneCWBVO,
  CWBVOCarouselContainer,
  CWBVOContainer,
  CWBVODetailsContainer,
  CWBVOStackCarouselArrowsContainer,
  CWBVOStackCarouselContainer,
  CWBVOStackCarouselItemContainer,
  DarkOnHoverContainer,
  DescriptionTypeOneCWBVO,
  FCOVOContainer,
  FCOVOItemContainerImage,
  FCOVOItemContainerLandscape,
  FCOVOItemContainerPortrait,
  FCOVOItemContainerText,
  HeadingAndDescriptionContainerTypeOneCWBVO,
  HeadingTypeOneCWBVO,
  NoScrollbarContainer,
  PublicListingStyledFilterDrawer,
  // TestimonialSectionContainer,
  //TestimonialItemContainer,
  //TestimonialContainer,
} from './ListingPageComponentStyles'
import { CircularProgress } from '@mui/material'

// Public Pages Generic Components:

export const ShadeBackgroundForPublicPagesVariantOne = ({ children }) => {
  return (
    <div style={{ background: '#fafafa', borderRadius: '0% 0% 100% 0% / 0% 0% 7% 0% ' }}>
      {children}
    </div>
  )
}

export const PublicListingComponentVarOne = ({
  heading,
  description,
  actionText,
  listItemsArray,
  sentryRef,
  areFiltersSelected,
  hasNextPage,
  onClickOverride,
  componentWrapperCustomStyles = {},
  CustomCardComponent,
  customCardGetActionButtonLogic,
  customCardGetMainImage,
  customCardGetSecondaryText,
  customCardGetTitleField,
  showFilterOption,
  filterOptionClickFunction,
  customCardProps = {},
}) => {
  // HDT : Heading, Description, Tiles

  const tilesSectionRef = useRef(null)
  const scrollToTilesFunction = () => {
    if (tilesSectionRef.current) {
      tilesSectionRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <ALPMainSectionContainer style={componentWrapperCustomStyles}>
      <ALPMainSectionInternalContainer>
        <ALPMainSectionHeading>{heading}</ALPMainSectionHeading>
        <ALPMainSectionDescription>{description}</ALPMainSectionDescription>
        {showFilterOption && filterOptionClickFunction && (
          <ALPDarkButton
            style={{ marginLeft: 'auto', marginTop: '10px', marginRight: '10px' }}
            onClick={filterOptionClickFunction}
          >
            <FilterAltOutlinedIcon />
            <div>Filter</div>
            {areFiltersSelected ? (
              <div
                style={{
                  height: '8px',
                  width: '8px',
                  background: '#cd0808',
                  borderRadius: '50%',
                  position: 'relative',
                  bottom: '6px',
                }}
              ></div>
            ) : (
              <></>
            )}
          </ALPDarkButton>
        )}
        <ALPMainSectionCaret
          onClick={scrollToTilesFunction}
          src={caret_purple_down}
          alt="caretDown"
          className="d-block mx-auto text-center mt-5"
        />
        <ALPMainSectionItemsContainer ref={tilesSectionRef}>
          {listItemsArray?.map((listItem, listItemIndex) => {
            if (CustomCardComponent) {
              return (
                <ALPMainSectionItemContainerOnClickOverride
                  key={listItemIndex}
                  style={{ height: 'unset' }}
                >
                  <CustomCardComponent
                    key={listItemIndex}
                    item={listItem}
                    getActionButtonLogic={customCardGetActionButtonLogic}
                    getMainImage={customCardGetMainImage}
                    getSecondaryText={customCardGetSecondaryText}
                    getTitleField={customCardGetTitleField}
                    noMargin
                    lightMode
                    idx={listItemIndex}
                    inFlexContainer={false}
                    {...customCardProps}
                  />
                </ALPMainSectionItemContainerOnClickOverride>
              )
            }

            if (onClickOverride) {
              //temporary - not a good way to do this, just keeping on click and link to separate
              return (
                <ALPMainSectionItemContainerOnClickOverride
                  key={listItemIndex}
                  onClick={() => onClickOverride(listItem)}
                >
                  {/* <a
                    href={listItem?.link}
                    style={{
                      display: 'block',
                      textDecoration: 'none',
                      color: 'inherit',
                      cursor: 'pointer',
                    }}
                    onClick={() => onClickOverride(listItem)}
                  > */}
                  <ALPMainSectionItemBackground
                    src={getImageLink(listItem?.imageId)}
                    alt="ALPBackground"
                  />
                  <ALPMainSectionItemDetails>
                    <ALPMainSectionItemHeading>{listItem?.title}</ALPMainSectionItemHeading>
                    <ALPMainSectionItemStartText>
                      <span>{actionText}</span>
                      <img src={rightCaret} style={{ height: '14px' }} alt="right" />
                    </ALPMainSectionItemStartText>
                  </ALPMainSectionItemDetails>
                  {/* </a> */}
                </ALPMainSectionItemContainerOnClickOverride>
              )
            } else {
              return (
                <ALPMainSectionItemContainer key={listItemIndex} to={listItem?.link}>
                  <ALPMainSectionItemBackground
                    src={getImageLink(listItem?.imageId)}
                    alt="BackgroundImage"
                  />
                  <ALPMainSectionItemDetails>
                    <ALPMainSectionItemHeading>{listItem?.title}</ALPMainSectionItemHeading>
                    <ALPMainSectionItemStartText>
                      <span>{actionText}</span>
                      <img src={rightCaret} style={{ height: '14px' }} alt="right" />
                    </ALPMainSectionItemStartText>
                  </ALPMainSectionItemDetails>
                </ALPMainSectionItemContainer>
              )
            }
          })}
          {hasNextPage && (
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              ref={sentryRef}
            >
              <CircularProgress />
            </div>
          )}
        </ALPMainSectionItemsContainer>
      </ALPMainSectionInternalContainer>
    </ALPMainSectionContainer>
  )
}

export const PublicListingFilterDrawer = ({
  isOpen,
  toggleDrawer,
  filters,
  tagsData,
  selectedFilters,
  changeSelectedFiltersFunction,
  applyFiltersFunction,
  actionButtonText,
}) => {
  async function applyFilters() {
    applyFiltersFunction()
    toggleDrawer()
  }

  function durationOnClick(clickedOption) {
    if (selectedFilters?.duration === clickedOption) {
      changeSelectedFiltersFunction({ ...selectedFilters, duration: null })
    } else {
      changeSelectedFiltersFunction({ ...selectedFilters, duration: clickedOption })
    }
  }

  function tagsOnClick(clickedOption) {
    if (selectedFilters?.tags?.includes(clickedOption)) {
      const newSelectedTags = [...selectedFilters?.tags]
      newSelectedTags.splice(newSelectedTags.indexOf(clickedOption), 1)
      changeSelectedFiltersFunction({
        ...selectedFilters,
        tags: newSelectedTags,
      })
    } else {
      changeSelectedFiltersFunction({
        ...selectedFilters,
        tags: [...selectedFilters?.tags, clickedOption],
      })
    }
  }

  function typeOnClick(clickedOption) {
    if (selectedFilters?.type === clickedOption) {
      changeSelectedFiltersFunction({ ...selectedFilters, type: null })
    } else {
      changeSelectedFiltersFunction({ ...selectedFilters, type: clickedOption })
    }
  }

  function courseTypeOnClick(clickedOption) {
    if (selectedFilters?.courseType === clickedOption) {
      changeSelectedFiltersFunction({ ...selectedFilters, courseType: null })
    } else {
      changeSelectedFiltersFunction({ ...selectedFilters, courseType: clickedOption })
    }
  }

  return (
    <PublicListingStyledFilterDrawer
      className="drawer"
      anchor="right"
      open={isOpen}
      transitionDuration={{ enter: 600, exit: 300 }}
      onClose={(event, reason) => {
        if (reason === 'backdropClick') {
          toggleDrawer()
        }
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'top' }}>
        <div>
          <div style={{ fontSize: '40px', fontWeight: '500', lineHeight: '45px' }}>Filter</div>
          <div style={{ color: '#6e6e6e', fontSize: '28px', fontWeight: '400' }}>
            ({calculateNumberOfFilters(selectedFilters)} Selected)
          </div>
        </div>
        <DarkOnHoverContainer round>
          <CloseIcon
            onClick={toggleDrawer}
            style={{ marginLeft: 'auto', cursor: 'pointer', fontSize: '32px' }}
          />
        </DarkOnHoverContainer>
      </div>

      <NoScrollbarContainer style={{ overflowY: 'auto' }}>
        <div style={{ height: '40px' }}></div>
        {filters?.duration && (
          <>
            <ALPFilterOptionHeading>Duration</ALPFilterOptionHeading>
            <ALPFilterOptionsContainer>
              <ALPFilterOption
                selected={selectedFilters?.duration === 'short'}
                onClick={() => durationOnClick('short')}
              >
                <div>
                  <b>Short</b>
                </div>
                <div style={{ fontWeight: 400, color: '#6e6e6e' }}>0 - 5 min</div>
              </ALPFilterOption>
              <ALPFilterOption
                selected={selectedFilters?.duration === 'medium'}
                onClick={() => durationOnClick('medium')}
              >
                <div>
                  <b>Medium</b>
                </div>
                <div style={{ fontWeight: 400, color: '#6e6e6e' }}>5 - 10 min</div>
              </ALPFilterOption>
              <ALPFilterOption
                selected={selectedFilters?.duration === 'long'}
                onClick={() => durationOnClick('long')}
              >
                <div>
                  <b>Long</b>
                </div>
                <div style={{ fontWeight: 400, color: '#6e6e6e' }}>15+ min</div>
              </ALPFilterOption>
            </ALPFilterOptionsContainer>
          </>
        )}
        {filters?.tags && Array.isArray(tagsData) && tagsData.length > 0 && (
          <>
            <ALPFilterOptionHeading>Categories</ALPFilterOptionHeading>
            <ALPFilterOptionsContainer>
              {tagsData?.map((item, index) => {
                if (index < 8) {
                  return (
                    <ALPFilterOption
                      selected={selectedFilters?.tags?.includes(item?.assessmentId)}
                      wider
                      key={item?.assessmentId}
                      onClick={() => tagsOnClick(item?.assessmentId)}
                    >
                      {item?.title}
                    </ALPFilterOption>
                  )
                }
                return <></>
              })}
            </ALPFilterOptionsContainer>
          </>
        )}
        {filters?.courseType && (
          <>
            <ALPFilterOptionHeading>Media Type</ALPFilterOptionHeading>
            <ALPFilterOptionsContainer>
              <ALPFilterOption
                selected={selectedFilters.courseType === 'audio'}
                onClick={() => courseTypeOnClick('audio')}
              >
                <div>
                  <HeadsetIcon />
                </div>
                <div>Audio</div>
              </ALPFilterOption>
              <ALPFilterOption
                selected={selectedFilters.courseType === 'video'}
                onClick={() => courseTypeOnClick('video')}
              >
                <div>
                  <OndemandVideoIcon />
                </div>
                <div>Video</div>
              </ALPFilterOption>
            </ALPFilterOptionsContainer>
          </>
        )}
        {filters?.type && (
          <>
            <ALPFilterOptionHeading>Course Type</ALPFilterOptionHeading>
            <ALPFilterOptionsContainer>
              <ALPFilterOption
                selected={selectedFilters.type === 'single'}
                onClick={() => typeOnClick('single')}
              >
                <div>Single Session</div>
              </ALPFilterOption>
              <ALPFilterOption
                selected={selectedFilters.type === 'multiple'}
                onClick={() => typeOnClick('multiple')}
              >
                <div>Multiple Sessions</div>
              </ALPFilterOption>
            </ALPFilterOptionsContainer>
          </>
        )}
      </NoScrollbarContainer>

      <ALPFilterFinalActionButton style={{ marginTop: '20px' }} onClick={applyFilters}>
        <div>{actionButtonText}</div>
        <div>
          <TrendingFlatIcon style={{ fontSize: '32px' }} />
        </div>
      </ALPFilterFinalActionButton>
    </PublicListingStyledFilterDrawer>
  )
}

export const InfoAndSingleActionComponentVarOne = ({
  headline,
  description,
  image,
  actionButtonText,
  clickFunction,
  actionButtonPath,
  descriptionStyles = {},
  mainContainerStyles = {},
}) => {
  return (
    <IASACVarOneContainer style={mainContainerStyles}>
      <IASACVarOneBackground>
        <IASACVarOneBackgroundImageOne />
        <IASACVarOneBackgroundImageTwo src={image} alt="backgroundImage" />
      </IASACVarOneBackground>
      <IASCDetailsContainer>
        <IASACVarOneHeading>{headline}</IASACVarOneHeading>
        {description && (
          <IASACVarOneDescription style={descriptionStyles}>{description}</IASACVarOneDescription>
        )}
        {clickFunction && (
          <IASACVarOneButton onClick={clickFunction}>{actionButtonText}</IASACVarOneButton>
        )}
      </IASCDetailsContainer>
    </IASACVarOneContainer>
  )
}

export const InfoWithHeadingDescriptionAndImage = ({
  headline,
  description,
  image,
  pictureOnLeftVariant,
}) => {
  if (pictureOnLeftVariant) {
    return (
      <IWHDAIVarOneContainer pictureOnLeftVariant={pictureOnLeftVariant}>
        <IWHDAIVarOneImage src={image} alt="ImageForHeading" />
        <DisplayFlexColumn style={{ justifyContent: 'center', width: '100%' }}>
          <IWHDAIVarOneHeadline2>{headline}</IWHDAIVarOneHeadline2>
          <IWHDAIVarOneDescription>{description}</IWHDAIVarOneDescription>
        </DisplayFlexColumn>
      </IWHDAIVarOneContainer>
    )
  } else {
    return (
      <IWHDAIVarOneContainer>
        <DisplayFlexColumn style={{ justifyContent: 'center' }}>
          <IWHDAIVarOneHeadline2>{headline}</IWHDAIVarOneHeadline2>
          <IWHDAIVarOneDescription>{description}</IWHDAIVarOneDescription>
        </DisplayFlexColumn>
        <IWHDAIVarOneImage src={image} alt="ImageForHeading" />
      </IWHDAIVarOneContainer>
    )
  }
}

export const FourCardsOptionsVariantOne = ({
  dataPortraitCards,
  dataLandscapeCards,
  hoverEffects = true,
}) => {
  const { width } = useScreenSize()
  return (
    <FCOVOContainer>
      {width >= 768
        ? dataPortraitCards?.map((item, index) => {
            return (
              <FCOVOItemContainerPortrait to={item?.link} key={index} hoverEffects={hoverEffects}>
                <FCOVOItemContainerImage src={getImageLink(item?.image)} alt="potraitImg" />
                <FCOVOItemContainerText>{item?.text}</FCOVOItemContainerText>
              </FCOVOItemContainerPortrait>
            )
          })
        : dataLandscapeCards?.map((item, index) => {
            return (
              <FCOVOItemContainerLandscape to={item?.link} key={index} hoverEffects={hoverEffects}>
                <FCOVOItemContainerImage src={getImageLink(item?.image)} alt="landscapeImg" />
                <FCOVOItemContainerText>{item?.text}</FCOVOItemContainerText>
              </FCOVOItemContainerLandscape>
            )
          })}
    </FCOVOContainer>
  )
}

export const AppDownloadComponent = ({ qrCodeVariant = false }) => {
  return (
    <ADCContainer>
      <ADCTitle hideOnLarge={true}>
        <b>The Most Personal Meditation & Self-Care</b>
      </ADCTitle>
      <ADCImagesAndDetails>
        {qrCodeVariant ? (
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <img
              style={{ width: '250px' }}
              src={getImageLink(APP_CONSTANTS.APP_DOWNLOAD_QR)}
              alt="app download qr"
            />
            <div style={{ textAlign: 'center', marginTop: '8px' }}>Get the App</div>
          </div>
        ) : (
          <ADCImagesContainer>
            <ADCImageOne
              src={getImageLink('MEDIA-515001ab4e07468ea589fcb915d61539')}
              alt="app in phone"
            />
            <ADCImageTwo
              src={getImageLink('MEDIA-906a62380393469cbfac54e14dd4c062')}
              alt="app in phone two"
            />
          </ADCImagesContainer>
        )}
        <div style={{ width: '100%', padding: '0 10px' }}>
          <ADCTitle>
            <b>The Most Personal Meditation & Self-Care</b>
          </ADCTitle>
          <ADCSubtext>Let the masters&apos; chalk out a plan, tailored for you.</ADCSubtext>
          <ADCStoreButtonsContainer>
            <img
              onClick={() => (window.location.href = APP_CONSTANTS.APP_STORE_APP_LINK)}
              src={app_store}
              alt="app store"
              style={{ cursor: 'pointer' }}
            />
            <img
              onClick={() => (window.location.href = APP_CONSTANTS.PLAY_STORE_APP_LINK)}
              src={play_store}
              alt="play store"
              style={{ cursor: 'pointer' }}
            />
          </ADCStoreButtonsContainer>
        </div>
      </ADCImagesAndDetails>
    </ADCContainer>
  )
}

export const CarouselWithButtonsVariantOne = ({
  backgroundColor,
  buttonColor,
  componentOne,
  itemsForStack,
  componentTwo,
  heightProp,
  gradientColor,
  StackComponent,
}) => {
  const { width } = useScreenSize()
  return (
    <CWBVOContainer backgroundColor={backgroundColor}>
      <CWBVODetailsContainer>
        {componentOne}
        {width < 768 && (
          <StackComponentForCarouselWithButtonsVarOne
            heightProp={heightProp}
            buttonColor={buttonColor}
            itemsForStack={itemsForStack}
            StackComponent={StackComponent}
          />
        )}
        {componentTwo}
      </CWBVODetailsContainer>
      {width >= 768 && (
        <CWBVOCarouselContainer>
          <StackComponentForCarouselWithButtonsVarOne
            heightProp={heightProp}
            buttonColor={buttonColor}
            itemsForStack={itemsForStack}
            StackComponent={StackComponent}
          />
        </CWBVOCarouselContainer>
      )}
      {/* {gradientColor && <CWBVOStackCarouselGradient gradientColor={gradientColor} />} */}
    </CWBVOContainer>
  )
}

// Related Items below a Feature:

export const RelatedAppFeaturesComponent = ({
  domainsArray,
  featuresArrayInOrder,
  courseCategory,
  techniqueId,
}) => {
  const navigate = useNavigate()
  const { unSecureSetupData } = useContext(UnsecureSetupContext)
  const [relatedArticlesData, setRelatedArticlesData] = useState()
  const [relatedAssessmentsData, setRelatedAssessmentsData] = useState()
  const [relatedJournalsData, setRelatedJournalsData] = useState()
  const [relatedMentorsData, setRelatedMentorsData] = useState()
  const [relatedActivityPlansData, setRelatedActivityPlansData] = useState()
  const [relatedCourseCategoryData, setRelatedCourseCategoryData] = useState()

  let domainIdsTextForApi = ''
  if (Array.isArray(domainsArray) && domainsArray.length > 0) {
    // domainIdsTextForApi = domainsArray.join(',')
    domainIdsTextForApi = ''
  }

  let relationshipTextForHeadings = ''
  if (domainsArray?.[0]) {
    relationshipTextForHeadings = ` for ${domainsArray[0]
      .replaceAll('_', ' ')
      .replaceAll('domain ', '')}`
  }
  if (domainsArray?.[1]) {
    relationshipTextForHeadings += ` and ${domainsArray[1]
      .replaceAll('_', ' ')
      .replaceAll('domain ', '')}`
  }

  const getDataForThisPage = useCallback(async () => {
    // call APIs on the basis of domains
    if (featuresArrayInOrder.includes('article')) {
      const responseArticles = await getFeatureList('article')
      if (responseArticles?.status === 200) {
        setRelatedArticlesData(responseArticles?.data)
      }
    }
    if (featuresArrayInOrder.includes('assessment')) {
      const responseAssessments = await getFeatureList('assessment', 1, {
        domainIds: domainIdsTextForApi,
      })
      if (responseAssessments?.status === 200) {
        setRelatedAssessmentsData(responseAssessments?.data)
      }
    }
    if (featuresArrayInOrder.includes('journal')) {
      const responseJournals = await getFeatureList('journal', 1, {
        domainIds: domainIdsTextForApi,
      })
      if (responseJournals?.status === 200) {
        setRelatedJournalsData(responseJournals?.data)
      }
    }
    if (featuresArrayInOrder.includes('mentor')) {
      const responseMentors = await getDataWithoutParams(
        '/api/external/mentor/1on1/list?categories=therapist',
      )
      // const responseMentors = await getFeatureList('mentor', 1, { categoryIds: 'therapist', domainIds: domainIdsTextForApi })
      if (responseMentors?.status === 200 && responseMentors?.data?.length > 0) {
        setRelatedMentorsData(
          responseMentors?.data?.filter(
            (item) => item?.slug && getDisplayEventTypesOfMentor(item)?.length > 0,
          ),
        )
      }
    }
    if (featuresArrayInOrder.includes('activity-plan')) {
      const responseActivityPlans = await getFeatureList('activity-plan', 1, {
        domainIds: domainIdsTextForApi,
      })
      if (responseActivityPlans?.status === 200 && responseActivityPlans?.data?.length > 0) {
        setRelatedActivityPlansData(responseActivityPlans?.data)
      }
    }
    if (featuresArrayInOrder.includes('course')) {
      const responseCourse = await getAllCoursesCategoryItemsForPublic(
        1,
        courseCategory,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        techniqueId,
      )
      if (responseCourse?.status === 200 && responseCourse?.data?.length > 0) {
        setRelatedCourseCategoryData(responseCourse?.data)
      }
    }
  }, [])

  useEffect(() => {
    getDataForThisPage()
  }, [])

  return featuresArrayInOrder?.map((item, index) => {
    if (
      item === 'article' &&
      Array.isArray(relatedArticlesData) &&
      relatedArticlesData.length > 0
    ) {
      return (
        <PublicListingListArticleLayoutCardWithCustomHeader
          key={index}
          HeadingComponent={RelatedAppFeaturesHeading}
          headingData={`Articles and Readings${titleCaseWithExceptionWords(
            relationshipTextForHeadings,
            ['for', 'and'],
          )}`}
          logicAndData={{
            items: [...relatedArticlesData],
            getTitleField: (item) => item?.title,
            onClick: (item) => {
              if (item?.slug) {
                navigate(`/article/${item?.slug}`)
              } else {
                navigate(`/article/id/${item?.assessmentId}`)
              }
            },
            getMainImage: (item) => getImageLink(item?.coverIcon),
            // getActionButtonLogic: () => ({
            //   text: 'Read',
            //   onClick: (item) => {
            //     if (item?.slug) {
            //       navigate(`/article/${item?.slug}`)
            //     } else {
            //       navigate(`/article/id/${item?.assessmentId}`)
            //     }
            //   },
            // }),
            getSecondaryText: (item) => item.description,
            lightMode: true,
            isAnchor: true,
            getTo: (item) => {
              return item?.slug ? `/article/${item?.slug}` : `/article/${item?.assessmentId}`
            },
          }}
        />
      )
    } else if (
      item === 'assessment' &&
      Array.isArray(relatedAssessmentsData) &&
      relatedAssessmentsData.length > 0
    ) {
      return (
        <PublicListingListSquareCardsWithCustomHeader
          key={index}
          HeadingComponent={RelatedAppFeaturesHeading}
          headingData={`Assessments and Tests${titleCaseWithExceptionWords(
            relationshipTextForHeadings,
            ['for', 'and'],
          )}`}
          logicAndData={{
            items: [...relatedAssessmentsData],
            getTitleField: (item) => item?.title,
            backgroundColor: '#557183',
            onClick: (item) => {
              if (item?.slug) {
                navigate(`/assessment/${item?.slug}`)
              } else {
                navigate(`/assessment/id/${item?.assessmentId}`)
              }
            },
            getMainImage: (item) => getImageLink(item?.coverIcon),
            getActionButtonLogic: () => ({
              text: 'Take',
              onClick: (item) => {
                if (item?.slug) {
                  navigate(`/assessment/${item?.slug}`)
                } else {
                  navigate(`/assessment/id/${item?.assessmentId}`)
                }
              },
            }),
            getSecondaryText: () => 'Assessment',
          }}
        />
      )
    } else if (
      item === 'journal' &&
      Array.isArray(relatedJournalsData) &&
      relatedJournalsData.length > 0
    ) {
      return (
        <PublicListingListSquareCardsWithCustomHeader
          key={index}
          HeadingComponent={RelatedAppFeaturesHeading}
          headingData={`Journals${titleCaseWithExceptionWords(relationshipTextForHeadings, [
            'for',
            'and',
          ])}`}
          logicAndData={{
            items: [...relatedJournalsData],
            getTitleField: (item) => item?.title,
            backgroundColor: '#557183',
            onClick: (item) => {
              if (item?.slug) {
                navigate(`/journal/${item?.slug}`)
              } else {
                navigate(`/journal/id/${item?.assessmentId}`)
              }
            },
            getMainImage: (item) => getImageLink(item?.coverIcon),
            getActionButtonLogic: () => ({
              text: 'Journal',
              onClick: (item) => {
                if (item?.slug) {
                  navigate(`/journal/${item?.slug}`)
                } else {
                  navigate(`/journal/id/${item?.assessmentId}`)
                }
              },
            }),
            getSecondaryText: () => 'Journal',
          }}
        />
      )
    } else if (
      item === 'mentor' &&
      Array.isArray(relatedMentorsData) &&
      relatedMentorsData.length > 0
    ) {
      return (
        <PublicListingListMentorCardPortraitWithCustomHeader
          key={index}
          HeadingComponent={RelatedAppFeaturesHeading}
          headingData={'Talk to an expert Therapist'}
          logicAndData={{
            items: [...relatedMentorsData],
            getTitleField: (item) => item?.name,
            getMainImage: (item) => getImageLink(item?.profilePicId),
            getSecondaryText: (profile) => {
              const exp = getYearsOfExperienceFromProfile(profile)
              if (exp >= 2) {
                return `${exp}+ years of experience`
              }
              return null
            },
            getTertiaryText: (profile) => {
              const languagesArrayData = getArrayOfLanguagesOfMentor(profile, unSecureSetupData)
              if (languagesArrayData?.length > 0) {
                return `Speaks: ${languagesArrayData?.join(', ')}`
              }
              return null
            },
            getPrimarySpecialText: () => null,
            getSecondarySpecialText: () => null,
            getTertiarySpecialText: () => null,
            getSecondaryActionButtonLogic: (item) => ({
              text: 'Explore',
              onClick: (item) => {
                navigate(`/mentor/${item?.slug}/events`)
              },
            }),
            getActionButtonLogic: (item) => ({
              text: 'Book',
              onClick: (item) => {
                const displayEventTypes = getDisplayEventTypesOfMentor(item)
                navigate(
                  `/mentor/${item?.slug}/events/${
                    displayEventTypes?.find((item) => !item?.free)?.uid
                  }`,
                )
              },
            }),
          }}
        />
      )
    } else if (
      item === 'activity-plan' &&
      Array.isArray(relatedActivityPlansData) &&
      relatedActivityPlansData.length > 0
    ) {
      return (
        <PublicListingListSquareCardsWithCustomHeader
          key={index}
          HeadingComponent={RelatedAppFeaturesHeading}
          headingData={`Plans${titleCaseWithExceptionWords(relationshipTextForHeadings, [
            'for',
            'and',
          ])}`}
          logicAndData={{
            items: [...relatedActivityPlansData],
            getTitleField: (item) => item?.title,
            backgroundColor: '#557183',
            onClick: (item) => {
              if (item?.slug) {
                navigate(`/plan/${item?.slug}`)
              } else {
                navigate(`/plan/id/${item?.assessmentId}`)
              }
            },
            getMainImage: (item) => getImageLink(item?.coverIcon),
            getActionButtonLogic: () => ({
              text: 'Get this Plan',
              onClick: (item) => {
                if (item?.slug) {
                  navigate(`/plan/${item?.slug}`)
                } else {
                  navigate(`/plan/id/${item?.assessmentId}`)
                }
              },
            }),
            getSecondaryText: () => 'Activity-Plan',
          }}
        />
      )
    } else if (
      item === 'course' &&
      Array.isArray(relatedCourseCategoryData) &&
      relatedCourseCategoryData.length > 0
    ) {
      return (
        <PublicListingListSquareCardsWithCustomHeader
          key={index}
          HeadingComponent={RelatedAppFeaturesHeading}
          headingData={
            courseCategory === 'meditation'
              ? `Guided Meditations${titleCaseWithExceptionWords(relationshipTextForHeadings, [
                  'for',
                  'and',
                ])}`
              : `CBTs${titleCaseWithExceptionWords(relationshipTextForHeadings, ['for', 'and'])}`
          }
          logicAndData={{
            items: [...relatedCourseCategoryData],
            getTitleField: (item) => item?.title,
            backgroundColor: '#557183',
            // onClick: (item) => {
            //   if (item?.slug) {
            //     navigate(`/c/view/${item?.slug}`)
            //   } else {
            //     navigate(`/c/view/id/${item?.assessmentId}`)
            //   }
            // },
            getMainImage: (item) => getImageLink(item?.coverIcon),
            // getActionButtonLogic: () => ({
            //   text: 'Explore',
            //   onClick: (item) => {
            //     if (item?.slug) {
            //       navigate(`/c/view/${item?.slug}`)
            //     } else {
            //       navigate(`/c/view/id/${item?.assessmentId}`)
            //     }
            //   },
            // }),
            getSecondaryText: () => {
              if (courseCategory === 'meditation') return 'Guided Meditation'
              else return 'CBT'
            },
            isAnchor: true,
            getTo: (item) => {
              return item?.slug ? `/c/view/${item?.slug}` : `/c/view/id/${item?.assessmentId}`
            },
          }}
        />
      )
    } else {
      return null
    }
  })
}

// Small Child Components:

export const RelatedAppFeaturesHeading = ({ data }) => {
  return <RelatedAppFeaturesStyledHeading>{data}</RelatedAppFeaturesStyledHeading>
}

const PublicListingListSquareCardsWithCustomHeader = ({
  HeadingComponent,
  headingData,
  logicAndData,
}) => {
  const [areTileItemsHovered, setAreTileItemsHovered] = useState(false)
  useEffect(() => {
    console.log({ logicAndData })
  }, [logicAndData])

  return (
    <div
      onMouseEnter={() => setAreTileItemsHovered(true)}
      onMouseLeave={() => setAreTileItemsHovered(false)}
    >
      {HeadingComponent && headingData && <HeadingComponent data={headingData} />}
      <SquareCardCarouselComponent
        areTileItemsHovered={areTileItemsHovered}
        logicAndData={logicAndData}
      />
    </div>
  )
}

const PublicListingListMentorCardPortraitWithCustomHeader = ({
  HeadingComponent,
  headingData,
  logicAndData,
}) => {
  const [areTileItemsHovered, setAreTileItemsHovered] = useState(false)

  return (
    <div
      onMouseEnter={() => setAreTileItemsHovered(true)}
      onMouseLeave={() => setAreTileItemsHovered(false)}
    >
      {HeadingComponent && headingData && <HeadingComponent data={headingData} />}
      <MentorCardPortraitCarouselComponent
        areTileItemsHovered={areTileItemsHovered}
        logicAndData={logicAndData}
      />
    </div>
  )
}

const PublicListingListArticleLayoutCardWithCustomHeader = ({
  HeadingComponent,
  headingData,
  logicAndData,
}) => {
  const [areTileItemsHovered, setAreTileItemsHovered] = useState(false)
  useEffect(() => {
    console.log({ logicAndData })
  }, [logicAndData])
  return (
    <div
      onMouseEnter={() => setAreTileItemsHovered(true)}
      onMouseLeave={() => setAreTileItemsHovered(false)}
    >
      {HeadingComponent && headingData && <HeadingComponent data={headingData} />}
      <ArticleLayoutCardCarouselComponent
        areTileItemsHovered={areTileItemsHovered}
        logicAndData={logicAndData}
      />
    </div>
  )
}

export const HeadingAndDescriptionForCWBVO = ({ headingText, descriptionText, textColor }) => {
  return (
    <HeadingAndDescriptionContainerTypeOneCWBVO>
      {headingText && (
        <HeadingTypeOneCWBVO textColor={textColor}>{headingText}</HeadingTypeOneCWBVO>
      )}
      {descriptionText && (
        <DescriptionTypeOneCWBVO textColor={textColor}>{descriptionText}</DescriptionTypeOneCWBVO>
      )}
    </HeadingAndDescriptionContainerTypeOneCWBVO>
  )
}

export const MobileScreenshotComponentForCWBVO = ({ data }) => {
  return <img src={getImageLink(data)} style={{ width: '100%' }} alt="app feature" />
}

export const PeopleCardComponentForCWBVO = ({ data }) => {
  return (
    <div
      style={{
        width: '100%',
        border: '1px solid rgb(63, 65, 67)',
        background: '#fff',
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer',
      }}
    >
      <Link
        style={{ textDecoration: 'none', color: '#2c384af2' }}
        to={`/mentor/${data?.slug}/events`}
      >
        <img src={getImageLink(data?.profilePicId)} alt="mentor" style={{ width: '100%' }} />
        <div
          style={{
            width: '100%',
            background: '#e7e7e7',
            textAlign: 'center',
            fontWeight: '500',
            padding: '10px 5px',
          }}
        >
          {data?.name}
        </div>
      </Link>

      {/* <div>{data?.shortDesc}</div> */}
      {/* Made Changes Over Here */}
    </div>
  )
}

export const ActionButtonForCWBVO = ({
  text,
  color,
  hoverBackground,
  hoverColor,
  linkTo,
  ...rest
}) => {
  return (
    <ActionButtonTypeOneCWBVO
      color={color}
      hoverBackground={hoverBackground}
      hoverColor={hoverColor}
      to={linkTo}
      {...rest}
    >
      {text}
    </ActionButtonTypeOneCWBVO>
  )
}

const StackComponentForCarouselWithButtonsVarOne = ({
  buttonColor,
  itemsForStack,
  heightProp,
  StackComponent,
}) => {
  const [activeCardIndex, setActiveCardIndex] = useState(0)
  return (
    <CWBVOStackCarouselContainer heightProp={heightProp}>
      {itemsForStack?.map((item, index) => {
        console.log({ item })
        return (
          <CWBVOStackCarouselItemContainer
            key={index}
            noTranslateValue={index === activeCardIndex}
            translateXValue={index < activeCardIndex ? 0 : (index - activeCardIndex) * 260}
            notVisible={index < activeCardIndex}
          >
            <StackComponent data={item} />
          </CWBVOStackCarouselItemContainer>
        )
      })}
      <CWBVOStackCarouselArrowsContainer>
        <CarouselButtonTypeOne
          buttonColor={buttonColor}
          leftVariant={true}
          disabled={activeCardIndex <= 0}
          clickFunction={() => setActiveCardIndex((prev) => prev - 1)}
        />
        <CarouselButtonTypeOne
          buttonColor={buttonColor}
          disabled={activeCardIndex >= itemsForStack?.length - 1}
          clickFunction={() => setActiveCardIndex((prev) => prev + 1)}
        />
      </CWBVOStackCarouselArrowsContainer>
    </CWBVOStackCarouselContainer>
  )
}

const CarouselButtonTypeOne = ({ buttonColor, leftVariant, disabled, clickFunction }) => {
  return (
    <span
      style={{
        height: '40px',
        width: '40px',
        borderRadius: '50%',
        border: '1px solid #000',
        borderColor: `${disabled ? '#929292' : buttonColor || '#000'}`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        transform: `${leftVariant ? 'rotate(180deg)' : 'rotate(0deg)'}`,
      }}
      onClick={() => {
        if (!disabled) {
          clickFunction()
        }
      }}
    >
      <svg
        width="18"
        height="20"
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.7287 17.2727L19.0014 9.00002L10.7287 0.727295L9.6392 1.80755L16.0653 8.22445H0V9.77559H16.0653L9.6392 16.1925L10.7287 17.2727Z"
          fill={`${disabled ? '#929292' : buttonColor || '#000'}`}
        ></path>
      </svg>
    </span>
  )
}

export function calculateNumberOfFilters(selectedFilters) {
  return (
    (selectedFilters?.duration ? 1 : 0) +
    (selectedFilters?.type ? 1 : 0) +
    (selectedFilters?.courseType ? 1 : 0) +
    (Array.isArray(selectedFilters?.tags) ? selectedFilters.tags.length : 0)
  )
}

// export const TestimonialSection = ({ testimonials, direction }) => {
//   // Log the testimonials to check their structure
//   console.log('testimonials:', testimonials)

//   const allTestimonials = [...testimonials, ...testimonials]
//   return (
//     <TestimonialSectionContainer>
//       <TestimonialContainer direction={direction || 'LTR'}>
//         {allTestimonials.map((testimonial, index) => (
//           <TestimonialItemContainer key={index}>
//             <div className="name-handle">
//               <div className="name">{testimonial.name}</div>
//               <div className="handle">{testimonial.handle}</div>
//             </div>
//             <div className="quote-logo"></div>
//             <div className="logo">
//               <img src={testimonial.logo} alt="Logo" />
//             </div>
//             <div className="quote">{testimonial.quote}</div>

//             <div className="profile-pic">
//               <img src={testimonial.profilePic} alt={`${testimonial.name} profile`} />
//             </div>
//           </TestimonialItemContainer>
//         ))}
//       </TestimonialContainer>
//     </TestimonialSectionContainer>
//   )
// }
